import { toFixed } from "../utils/helpers";
import { cBigNumber } from "./BigNumber";


export class cStrike {
	initial: cBigNumber;
	formatted: string;

	constructor(strikeResponse: string){
		this.initial = new cBigNumber(strikeResponse);
		this.formatted = +toFixed(
			strikeResponse,
			+strikeResponse > 10
				? 0
				: +strikeResponse > 1
					? 1
					: 2
		) + '';
	}
}